const convertToBlack = (canvas: HTMLCanvasElement): Promise<void> => {
  return new Promise((resolve) => {
    const ctx = canvas.getContext('2d', { alpha: false });
    if (!ctx) {
      resolve();
      return;
    }

    const { width, height } = canvas;
    const imgData = ctx.getImageData(0, 0, width, height);
    const worker = new Worker(new URL('./convertToBlackWorker.ts', import.meta.url));
    worker.postMessage({ imgData, width, height }, { transfer: [imgData.data.buffer] });
    worker.onmessage = (event: MessageEvent<{ imgData: ImageData }>) => {
      const { imgData: resultImgData } = event.data;
      ctx.putImageData(resultImgData, 0, 0);
      worker.terminate();
      resolve();
    };
  });
};

export default convertToBlack;
